import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../api/queryKeys';
import { outletService } from '../api/services/outletService';
import type { OutletDto } from '../api/types/dine.types';

/** GET /outlet — rarely changes; cached for the session (10 min stale). */
export function useOutlet() {
  return useQuery<OutletDto, Error>({
    queryKey: queryKeys.outlet(),
    queryFn: () => outletService.get(),
    staleTime: 10 * 60_000,
  });
}
